import Icon from './Icon';

export { type ValidIcon } from './Icon';

export default Icon;
